module.exports = __webpack_public_path__ + "img/logo-locatelli.b92a96b2.jpeg";